


















import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
	name: 'CompanyNews',
	validate({ params }) {
		return params.id !== undefined && params.id.length !== -1
	},
	async asyncData({ params, $axios }) {
		const { data } = await $axios.get(`/api/news/${params.id}`)
		return {
			articleId: params.id,
			article: data ? data.article : null,
		}
	},
	data() {
		return {
			article: null as any,
			articleId: null as string|null,
			now: moment(),
			relatedArticles: null as string|null,
		}
	},
	head(this: any) {
		let headline = this.article ? this.article.headline : null

		if (headline && headline.length > 50) {
			headline = `${headline.substring(0, 47)}...`
		}

		return {
			title: headline ? `${headline} | WithIn` : 'WithIn News',
			meta: [{
				hid: 'description',
				name: 'description',
				content: this.article && this.article.summary
					? `${this.article.summary.substring(0, 150)}...`
					: this.$t('meta.description').toString(),
			}],
		}
	},
	mounted() {
		this.$axios.get(`/api/news/${this.articleId}`).then((resp) => {
			this.article = resp.data.article
		})

		this.$axios.get(`/api/news/${this.articleId}/related`, {
			params: {
				limit: 4,
			},
		}).then((resp) => {
			this.relatedArticles = resp.data.news
		})
	},
})
